import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/font-awesome': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M397.8 32c27.5 0 50.2 22.7 50.2 50.2v347.6c0 27.5-22.7 50.2-50.2 50.2h-347.6c-27.5 0-50.2-22.7-50.2-50.2v-347.6c0-27.5 22.7-50.2 50.2-50.2h347.6zM352.4 316.3h0.1v-140.3c0-4.2-4.2-7.8-9-7.8-6 0-31.1 16.1-53.8 16.1-4.7 0-8.9-0.6-13.1-2.4-20.3-7.7-38.2-13.7-60.9-13.7-20.9 0-43 6.5-61.5 14.3-1.8 1.2-3.6 1.8-5.4 2.4v-18.5c8.3-6 13.1-15.5 13.1-26.3 0-18.6-15-33.5-33.5-33.5-18.6 0-33.5 15-33.5 33.5 0 10.8 5.3 20.3 13.1 26.3v218.6c0 11.3 9 20.3 20.3 20.3 8.9 0 16.7-5.9 19.1-14.3v-1.2c0.6-1.2 0.6-3 0.6-4.8v-45.4c1.2-0.6 2.4-0.6 3.6-1.2 19.7-8.9 44.2-17.3 67.5-17.3 32.3 0 44.8 16.7 71.7 16.7 19.2 0 37.1-6.5 53.8-13.7 4.2-1.8 7.8-3.6 7.8-7.8z'
      }
    ]
  }
})
